import React from "react";
import { PageHeight60, scrollToTop } from "../../../components/Utils";
import NewsArticleForm from "../components/NewsArticleForm";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadArticle, saveArticle, cancelArticle } from "../actions";
import { FormMenu } from "../../../components/Buttons";

const frontload = async (props) => {
  const id = props.match.params.id;
  await props.getArticle({ id });
};
const mapStateToProps = (state) => {
  return {
    article: state.news.article,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getArticle: (...args) => dispatch(loadArticle(...args)),
  saveArticle: (...args) => dispatch(saveArticle(...args)),
  cancelArticle: (...args) => dispatch(cancelArticle(...args)),
});

function NewsWizard({
  article,
  history,
  saveArticle,
  cancelArticle,
  className = "",
  categoryName = "general",
  disabled,
}) {
  const formRef = React.useRef(null);
  React.useEffect(() => {
    scrollToTop();
    return () => {
      cancelArticle();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCancel = () => {
    let url = "#";
    switch (categoryName) {
      case "Sales":
        url = `/sales/news-feed`;
        break;
      default:
        url = `/news-service/beitraege`;
        break;
    }
    history.replace(url);
  };
  const onSave = () => {
    const model = formRef.current.getModel();
    if (!model) {
      return;
    }
    // category
    let category_id = 1;
    switch (categoryName) {
      case "Sales":
        category_id = 2;
        break;
      default:
        break;
    }
    model.category_id = category_id;
    saveArticle(model, onCancel);
  };

  if (!article) return null;
  return (
    <PageHeight60 id="/nachrichten">
      <NewsArticleForm
        ref={formRef}
        model={article}
        className={`w3-border no-border-top pad-big ${className}`}
        disabled={disabled}
      />
      <FormMenu
        className="w3-border no-border-top pad-big w3-light-grey"
        onSave={onSave}
        onCancel={onCancel}
        saveBtnName="saveNewsArticleBtn"
        saveHidden={disabled}
        cancelBtnLabel={disabled ? "Schließen" : "Abbrechen"}
        cancelBtnName="cancelNewsArticleBtn"
      />
    </PageHeight60>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(NewsWizard),
);
